// src/lib/alarma.ts
// Alarma sonora para alertas nuevas — WebAudio, sin archivos.
// Los navegadores bloquean audio hasta que hay una interacción del usuario;
// como el operador se loguea (click), el contexto queda habilitado.

let ctx: AudioContext | null = null;

function getCtx(): AudioContext | null {
  if (typeof window === 'undefined') return null;
  if (!ctx) {
    const AC = (window.AudioContext || (window as any).webkitAudioContext);
    if (!AC) return null;
    ctx = new AC();
  }
  if (ctx.state === 'suspended') ctx.resume().catch(() => {});
  return ctx;
}

/** Habilita el audio tras un gesto del usuario (llamar en el primer click/login). */
export function armarAlarma(): void {
  getCtx();
}

/** Dos beeps agudos tipo sirena. */
export function sonarAlarma(): void {
  const ac = getCtx();
  if (!ac) return;
  const now = ac.currentTime;
  [0, 0.35].forEach((offset) => {
    const osc = ac.createOscillator();
    const gain = ac.createGain();
    osc.type = 'square';
    osc.frequency.setValueAtTime(880, now + offset);
    osc.frequency.setValueAtTime(1180, now + offset + 0.15);
    gain.gain.setValueAtTime(0.001, now + offset);
    gain.gain.exponentialRampToValueAtTime(0.25, now + offset + 0.02);
    gain.gain.exponentialRampToValueAtTime(0.001, now + offset + 0.28);
    osc.connect(gain).connect(ac.destination);
    osc.start(now + offset);
    osc.stop(now + offset + 0.3);
  });
}
